import React from "react";
import { Wordmark } from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-ink-900 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <Wordmark />
            <p className="mt-6 text-sm text-steel-light leading-relaxed max-w-sm">
              Sanitary engineers and licensed plumbers, established 1972. Trusted across
              residential, commercial, industrial and Mivan-built developments.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">Navigation</div>
            <ul className="mt-5 space-y-3 text-sm text-steel-light">
              <li><a href="#about" className="hover:text-gold transition-colors">Legacy</a></li>
              <li><a href="#services" className="hover:text-gold transition-colors">Services</a></li>
              <li><a href="#mivan" className="hover:text-gold transition-colors">Mivan Technology</a></li>
              <li><a href="#projects" className="hover:text-gold transition-colors">Projects</a></li>
              <li><a href="#contact" className="hover:text-gold transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">Partners · Direct</div>
            <ul className="mt-5 space-y-4 text-sm text-steel-light">
              <li>
                <div className="text-white font-display text-lg leading-tight">Hemal Busa</div>
                <a href="tel:+919819608652" className="block hover:text-gold transition-colors">+91 98196 08652</a>
                <a href="mailto:hemalbusa@rediffmail.com" className="block hover:text-gold transition-colors">hemalbusa@rediffmail.com</a>
              </li>
              <li>
                <div className="text-white font-display text-lg leading-tight">Devang Mehta</div>
                <a href="tel:+919920440732" className="block hover:text-gold transition-colors">+91 99204 40732</a>
                <a href="mailto:dmehta413@gmail.com" className="block hover:text-gold transition-colors">dmehta413@gmail.com</a>
              </li>
              <li className="pt-2 font-mono text-[10px] uppercase tracking-[0.28em] text-steel">1805, Chandak Unicorn, Andheri (W), Mumbai — 400053</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-steel">
            © {new Date().getFullYear()} P. Jasvantrai &amp; Co. — All rights reserved.
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-steel">
            Estd. 1972 · Sanitary Engineers · Licensed Plumbers
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
